import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import React from 'react';

import SessionCardComponent from '../components/SessionCardComponent';
import { formatDateForSessionCard } from '../utils/other';
import routeConstants from '../utils/routeConstants';

class SessionCardContainer extends React.Component {
  routeToSingleSession(id) {
    this.props.dispatch(push(routeConstants.SINGLE_SESSION_ROUTE(id)));
  }

  render() {
    const {
      picture,
      name,
      sub_name: subName,
      venue_address: address,
      venue_club_name: venueClubName,
      session_id: sessionId,
      event_date: eventDate,
      start_time: startTime,
      booking_availability_status: bookingAvailabilityStatus
    } = this.props.event;
    return (
      <SessionCardComponent
        picture={ picture }
        time={ formatDateForSessionCard(startTime, eventDate) }
        name={ name }
        subname={ subName }
        address={ address }
        venueClubName={ venueClubName }
        bookingAvailabilityStatus={ bookingAvailabilityStatus }
        goToSession={ () => this.routeToSingleSession(sessionId) }
        startQuickBooking={ this.props.startQuickBooking }
        pendingBooking={ this.props.pendingBooking }
      />
    );
  }
}

SessionCardContainer.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    picture: PropTypes.string,
    name: PropTypes.string,
    sub_name: PropTypes.string,
    venue_address: PropTypes.string,
    venue_club_name: PropTypes.string,
    event_date: PropTypes.string,
    start_time: PropTypes.string,
    session_id: PropTypes.string,
    booking_availability_status: PropTypes.string
  }),
  dispatch: PropTypes.func.isRequired,
  startQuickBooking: PropTypes.func,
  pendingBooking: PropTypes.bool
};

SessionCardContainer.defaultProps = {
  event: {
    id: null,
    picture: '',
    name: '',
    sub_name: '',
    venue_address: '',
    venue_club_name: '',
    event_date: '',
    start_time: '',
    session_id: '',
    booking_availability_status: ''
  },
  startQuickBooking: () => {},
  pendingBooking: false
};

export default connect()(SessionCardContainer);



// WEBPACK FOOTER //
// ./src/containers/SessionCardContainer.js